<script setup lang="ts">
const cookiePolicy = ref("");
const { $i18n } = useNuxtApp();

onMounted(() => {
  fetch(`/api/policies/CookiePolicy?locale=${$i18n.locale.value}`)
    .then((response) => response.text())
    .then((data) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = String(data ?? "");
      const styleTags = tempDiv.getElementsByTagName("style");
      Array.from(styleTags).forEach((style) => {
        let cssText = style.innerHTML;

        cssText = cssText.replace(/([^{}]*){/g, (match, p1) => {
          if (
            p1.includes("cky-banner-element") ||
            p1.includes("cky-audit-table-element")
          ) {
            return match;
          }
          return `.cookie-container ${p1}{`;
        });
        style.innerHTML = cssText;
      });

      cookiePolicy.value = tempDiv.innerHTML;
    });
});
// Steps for preparing html doc:
// Ensure line-height is set to 2 everywhere
// replace red cookieYes tags with correct classes
</script>

<template>
  <div class="cookie-container" v-html="cookiePolicy"></div>
</template>

<style scoped>
.cky-banner-element {
  /* style as a button */
  background-color: #000;
  color: #fff;
  padding: 10px 20px;
  border-radius: 5px;
}
</style>
